import EventStandings, { EventStandingsFragment } from '-/Event/EventStandings';
import { useLocalSearchParams } from 'expo-router';
import { ScrollView } from 'react-native';
import { useQuery } from 'urql';
import Box from '@/components/UI/Box';
import Text from '@/components/UI/Text';
import WidgetPoweredBy from '@/components/Widget/WidgetPoweredBy';
import { graphql } from '@/gql/graphql';

const GetWidgetStandings = graphql(/* GraphQL */ `
  query GetWidgetStandings($eventId: uuid!) {
    event_by_pk(id: $eventId) {
      title
    }
    ...EventStandings
  }
`, [EventStandingsFragment]);

export default function WidgetStandings() {
  const { eventId = '' } = useLocalSearchParams<{
    eventId: string;
  }>();

  const [{ data, fetching }] = useQuery({
    query: GetWidgetStandings,
    variables: {
      eventId,
    },
    pause: !eventId,
  });

  return (
    <Box direction="vertical" flex>
      <Box py="xl" borderBottomWidth={2} border="divider">
        <Text bold numberOfLines={1} size="2xl" center>
          {data?.event_by_pk?.title}
        </Text>
      </Box>
      <ScrollView nestedScrollEnabled>
        <Box>
          <EventStandings data={data} fetching={fetching} />
        </Box>
      </ScrollView>
      <WidgetPoweredBy />
    </Box>
  );
}
